module.exports = __webpack_public_path__ + "static/media/fluttersvg.bd9fec89.svg";